<template>
<div v-if="!init" class="flex h-full justify-center items-center py-60">
    <n-spin size="small" />
</div>
<template v-else>
    <super-table
        showSearch
        :filters="filters"
        :refFilters="refFilters"
        :pager="cyclesDataTable.pager"
        :columns="columns"
        :loading="loadings.table"
        :records="cyclesDataTable.records"
        :filtersChanged="filtersChanged"
        columnsStorageName="__columns_transactions_table"
        type="cycles_table"
        @getData="cyclesGet"
        @sortColumn="sortColumn"
        @doSomething="doSomething"
        @reset-filters="resetFilters"
        @applyFilters="changeFilter">
        <template #afterSearch>
            <div class="flex items-center justify-start mx-2">
                <div class="hover:text-main dark:hover:text-main text-gray-600 dark:text-white/75 cursor-pointer mr-2" @click="downloadData('xls')">
                    <n-icon class="text-2xl">
                        <ClipboardDataBar24Regular />
                    </n-icon>
                    <div class="text-xs text-center -mt-2 font-bold">XLS</div>
                </div>
                <div class="hover:text-main dark:hover:text-main text-gray-600 dark:text-white/75 cursor-pointer ml-2" @click="downloadData('csv')">
                    <n-icon class="text-2xl">
                        <ClipboardDataBar24Regular />
                    </n-icon>
                    <div class="text-xs text-center -mt-2 font-bold">CSV</div>
                </div>
            </div>
        </template>
    </super-table>
</template>
</template>

<script>
// general
import general from './general';

// icon
import {
    ArrowLeft12Regular,
    ChevronLeft24Filled,
    ErrorCircle20Regular,
    ClipboardDataBar24Regular } from '@vicons/fluent';

// components
import RbCoin from '@components/rb-coin';
import RbSwitch from '@components/rb-switch';
import RbCheckbox from '@components/rb-checkbox';
import FilterBots from '@components/filters/bots';
import ResetFixOrder from '@components/stats-management/reset-fix-order/desktop.vue';
import BaseModal from '@components/base/base-modal';
import FilterStates from '@components/filters/states';
import FilterStatuses from '@components/filters/statuses';
import SuperTable from '@components/super-table/desktop.vue';
import FilterExchanges from '@components/filters/exchanges';
import InsuranceOrder from '@components/stats-management/insurance-order/desktop.vue';

// UI
import {
    NTag,
    NIcon,
    NCard,
    NTabs,
    NSpin,
    NModal,
    NButton,
    NTabPane,
    NDivider,
    NSkeleton,
    NScrollbar,
    NDatePicker } from 'naive-ui';

export default {
    name: 'trade-statistic-transactions-desktop',
    components: {
        NTag,
        NIcon,
        NCard,
        NTabs,
        NSpin,
        NModal,
        RbCoin,
        NButton,
        NDivider,
        RbSwitch,
        NTabPane,
        SuperTable,
        BaseModal,
        NSkeleton,
        RbCheckbox,
        NScrollbar,
        FilterBots,
        NDatePicker,
        FilterStates,
        ResetFixOrder,
        InsuranceOrder,
        FilterStatuses,
        FilterExchanges,
        ArrowLeft12Regular,
        ChevronLeft24Filled,
        ErrorCircle20Regular,
        ClipboardDataBar24Regular,
    },
    setup(props, context) {
        
        return {
            ...general(props, context),
        };
    },
};
</script>